export const MAX_PERCENT_VALUE = 100;
export const MIN_PERCENT_VALUE = 0;
export const INACTIVE_VARIANT = 'inactive';
export const NEGATIVE_VARIANT = 'negative';